export default __webpack_public_path__ + "static/media/sad.1163d8ec.svg";